module.exports = __webpack_public_path__ + "static/media/zhuzijianshanicon.6d822b24.webp";